var map = {
	"./1.jpg": 6123,
	"./10.jpg": 6991,
	"./11.jpg": 7877,
	"./12.jpg": 121,
	"./13.jpg": 2945,
	"./14.jpg": 7427,
	"./15.jpg": 2638,
	"./16.jpg": 9836,
	"./17.jpg": 7481,
	"./18.jpg": 6827,
	"./19.jpg": 1552,
	"./2.jpg": 5353,
	"./20.jpg": 1142,
	"./3.jpg": 9790,
	"./4.jpg": 9510,
	"./5.jpg": 7386,
	"./6.jpg": 6560,
	"./7.jpg": 5870,
	"./8.jpg": 6139,
	"./9.jpg": 6121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8883;